const PricingHero = () => {
  return (
    <div className="relative py-16 px-4 overflow-hidden">
      {/* Warm gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/8 via-circle-secondary/5 to-primary/8"></div>
      <div className="absolute top-10 left-1/4 w-72 h-72 bg-circle-secondary/15 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 right-1/4 w-72 h-72 rounded-full blur-3xl"></div>

      <div className="container mx-auto relative z-10">
        <div className="text-center">
          {/* Headline */}
          <h1 className="text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Choose Your <span className="text-primary">Home Support System</span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed mb-4">
            Whether you are building independence for yourself or supporting someone you love, SeniorThrive grows with you.
          </p>
          <p className="text-muted-foreground">
            Currently in early access. No commitment required.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PricingHero;
